module.exports = __webpack_public_path__ + "static/media/featured_player.6de3706a.png";